module.exports = __webpack_public_path__ + "static/media/lb.5e6ca722.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lb.svg
// module id = 874
// module chunks = 0